import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SpacesDispensesHD } from '../../interfaces/IHDspace';
import { LockerActionDataService } from '../../services/locker-action-data/locker-action-data.service';
import { SPACE_STATES } from '../../utils/constants';

@Component({
  selector: 'frodo-locker-space',
  templateUrl: './locker-space.component.html',
  styleUrls: ['./locker-space.component.scss'],
})
export class LockerSpaceComponent {
  @Input() space: SpacesDispensesHD;
  @Input() isSelected = false;

  @Output() clickSpace = new EventEmitter<SpacesDispensesHD>();

  constructor(private lockerActionDataService: LockerActionDataService) {}

  getSpaceClass(): string {
    const spaceClass = ['locker-space'];

    if (this.space?.dispenses?.length) {
      spaceClass.push(this.space.dispenses[0].state);
    }

    if (this.isSelected) {
      spaceClass.push('selected');
    }

    if (this.isSpaceDisabled()) {
      spaceClass.push('disabled');
    }

    return spaceClass.join(' ');
  }

  getDispenseTime() {
    return this.lockerActionDataService.getDispenseTime(this.space);
  }

  clickHandler() {
    this.clickSpace.emit(this.space);
  }

  isSpaceFaulty() {
    return this.lockerActionDataService.isSpaceFaulty(this.space);
  }

  isSpaceDisabled() {
    return this.space.state?.selectable === SPACE_STATES.DISABLE;
  }
}
